import http from '@/utils/services/http'

export const checaDisponibilidade = () => {
  let url = '/api/integra/porto-remocao/checa-disponibilidade'
  return http.get(url)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const sincronizar = (status = null, conta = null) => {
  let url = '/api/integra/porto-remocao/sincronizar'
  let data = {}
  if (status) data.status = status
  if (conta) data.conta = conta
  return http.post(url, data)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const consultar = (idStatus = 1603, conta = null) => {
  let url = `/api/integra/porto-remocao/consultar?idStatus=${idStatus}`
  if (conta) url = url + `&conta=${encodeURIComponent(conta)}`
  return http.get(url)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const alterarStatusBem = (id, idStatus, comentario = null) => {
  let url = `/api/integra/porto-remocao/bem/${id}/status`
  return http.post(url, {idStatus, comentario})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}
